export const StaffPermissionType = {
  SHOW_STAFF_PERMISSON: `SHOW_STAFF_PERMISSON`,
  ADD_STAFF_PERMISSON: `ADD_STAFF_PERMISSON`,
  DELETE_STAFF_PERMISSON: "DELETE_STAFF_PERMISSON",
  SHOWSTAFF_PERMISSON: "SHOWSTAFF_PERMISSON",
  UPDATE_STAFF_PERMISSION: "UPDATE_STAFF_PERMISSION",
};
